var map = {
	"./10_nuts.png": 2108,
	"./1drink_12beer.png": 2109,
	"./1serving_8ounces.png": 2110,
	"./1serving_8ounces2.png": 2111,
	"./1serving_8ounces3.png": 2112,
	"./1serving_8ounces4.png": 2113,
	"./1serving_8ounces5.png": 2114,
	"./8ounces_1glass.png": 2115,
	"./can_1.png": 2116,
	"./can_2.png": 2117,
	"./can_3.png": 2118,
	"./cup.png": 2119,
	"./dried_serving_1/4cup.png": 2120,
	"./dried_serving_1:4cup.png": 2121,
	"./fresh_serving_1cup.png": 2122,
	"./glass_1.png": 2123,
	"./glass_2.png": 2124,
	"./golfball.png": 2125,
	"./halfthumb.png": 2126,
	"./hand_1.png": 2127,
	"./hand_2.png": 2128,
	"./hand_3.png": 2129,
	"./hand_4.png": 2130,
	"./hand_5.png": 2131,
	"./how.png": 1004,
	"./serving_1/2cup.png": 2132,
	"./serving_1:2cup.png": 2133,
	"./serving_1tbsp.png": 2134,
	"./serving_3/4ounces.png": 2135,
	"./serving_3:4ounces.png": 2136,
	"./thumbx2.png": 2137,
	"./usda.png": 2138,
	"./vegetables_1cup.png": 2139,
	"./what.png": 1002,
	"./wholethumb.png": 2140,
	"./why.png": 1003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2107;